import Vue from 'vue'
import * as Tabs from 'vue-slim-tabs'

Vue.use(Tabs)



// WEBPACK FOOTER //
// ./src/front/init/components/slim-tab.js